import $api from 'http'
import $apiJSON from 'http/apiJSON'

export async function getTariffSubscription(data) {
  return $api.get(`/subscription/`, data)
}


export async function getTariffSubscriptionInfo(data) {
  return $api.get(`/subscription-info/`, data)
}

export async function getTariffOrders(data) {
  return $api.get(`/orders-employee/`, data)
}

export async function getUserServices(data) {
  return $api.get(`/user-services/`, data)
}
export async function PostStartTrialPeriod(id) {
  return $api.post(`/user-services/${id}/`, )
}

export async function getAllServices(data) {
  return $api.get(`/all-services/`, data)
}

export async function getUserAdminServices(data) {
  return $api.get(`/user-services-admin/`, data)
}

export async function createMyMicroService(data) {
  return $apiJSON.post(`/microservice-order/`, data)
}
export async function requestNewTariff(tarif) {
  return $apiJSON.post(`/application-tariff/`, tarif)
}
export async function consultationTariff(tarif) {
  return $apiJSON.post(`/tariff-consultation/`, tarif)
}
export async function createCustomTariff(data) {
  return $apiJSON.post(`/new-tariff/`, data)
}
export async function ChangeTheme() {
  return $apiJSON.post(`/employees/changethem/`, )
}

